export default "<ion-label>{{title}}</ion-label>\n<ng-content></ng-content>";